import gql from 'graphql-tag';

export default gql`
	query GetNameFromlatlng($latitude: String!, $longitude: String!) {
		getNameFromlatlng(lat: $latitude, lng: $longitude) {
			address
		}
	}
`;
